var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-uploader',{attrs:{"accept":_vm.accept,"after-read":_vm.afterRead,"before-delete":_vm.beforeDelete,"file-list":_vm.fileList,"max-count":_vm.maxCount,"max-size":_vm.maxSize,"result-type":"file"},on:{"oversize":_vm.onOversize}})}
var staticRenderFns = []

export { render, staticRenderFns }